import axios from "axios";

function getCarModels(idCD, marca, anio, modelo, polkoClientes) {
    let carVersionsUrl = process.env.REACT_APP_BACK_SERVER + '/getVersionesAutos';

    return axios.get(carVersionsUrl, {
        params: {
            'idcanaldigital': idCD,
            'marca': marca,
            'anio': anio,
            'modelo': modelo,
            ...(polkoClientes && { origen: "polko_clients" }),
        }
    });
}

export default getCarModels;
